import { render, staticRenderFns } from "./DataAdministrationAccountRebuild.vue?vue&type=template&id=4537840b&scoped=true"
import script from "./DataAdministrationAccountRebuild.vue?vue&type=script&lang=js"
export * from "./DataAdministrationAccountRebuild.vue?vue&type=script&lang=js"
import style0 from "./DataAdministrationAccountRebuild.vue?vue&type=style&index=0&id=4537840b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4537840b",
  null
  
)

export default component.exports